import { render, staticRenderFns } from "./ReviewCard.htm?vue&type=template&id=2129e90b&scoped=true&"
import script from "./ReviewCard.ts?vue&type=script&lang=js&"
export * from "./ReviewCard.ts?vue&type=script&lang=js&"
import style0 from "./ReviewCard.scss?vue&type=style&index=0&id=2129e90b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2129e90b",
  null
  
)

export default component.exports